<script setup lang="tsx">
import type { Response, ThreatMeta } from '@/models/api-generated'
import http from '@/services/http'
import { ref } from 'vue'
import Multiselect from 'vue-multiselect'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const availableThreats = ref<ThreatMeta[]>([])
const searchQuery = ref('')

const emit = defineEmits<{
	(e: 'select', threat: ThreatMeta): void
}>()

const props = defineProps<{
	exclude: number[]
}>()

const model = defineModel<ThreatMeta | undefined>({ required: true })

async function search(query: string) {
	const { data } = await http.get<Response<ThreatMeta[]>>('/api/threat/search', {
		params: { q: query, exclude: props.exclude.join(',') },
	})
	availableThreats.value = data.data || []
}

function onSelect(threat: ThreatMeta) {
	emit('select', threat)
}
</script>

<template>
	<Multiselect
		:multiple="false"
		:show-labels="false"
		:options="availableThreats"
		:internal-search="false"
		:preserve-search="true"
		:show-no-results="false"
		v-model="model"
		track-by="id"
		@search-change="search"
		@open="search(searchQuery)"
		@select="onSelect"
		:placeholder="t('misc.search') + '...'"
	>
		<template #option="{ option }">
			<span :data-test="'threat-option-' + option.id"> {{ option.threat.name }} ({{ option.threat.code }}) </span>
		</template>
	</Multiselect>
</template>
